import * as React from "react";
import ChevronPanel from "source/app/presentation/Shared/ChevronPanel/ChevronPanel";
import { DreamHashTags } from "./DreamHashTags";

export function DreamHashTagsChevronPanel() {
    return (
        <ChevronPanel id="dreamHashTags" label="Hashtags">
            <DreamHashTags shouldDisplay={true} />
        </ChevronPanel>
    );
}
